import React from "react";
import { MessageCircle, Download } from "lucide-react";
import { useLang } from "../../context/LanguageContext";

export const WhatsAppFloat = () => {
  const { t } = useLang();
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3" data-testid="floating-actions">
      <a
        href="/KisanDrone_Catalogue_2026.pdf"
        download
        target="_blank"
        rel="noreferrer"
        className="group flex items-center gap-2 pl-3 pr-4 py-2.5 rounded-full bg-[#F5A623] text-[#041209] font-semibold text-sm shadow-xl shadow-[#F5A623]/30 hover:bg-[#FDE68A] transition-all hover:-translate-y-0.5"
        data-testid="floating-catalogue-btn"
        aria-label={t("footer.downloadCatalogue")}
      >
        <Download className="w-4 h-4" />
        <span className="hidden sm:inline">{t("footer.downloadCatalogue")}</span>
      </a>
      <a
        href="https://wa.me/919112692979?text=Hi%20KisanDrone%2C%20I%27m%20interested%20in%20your%20agriculture%20drones"
        target="_blank"
        rel="noreferrer"
        className="relative w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl shadow-[#25D366]/30 flex items-center justify-center hover:scale-110 transition-transform"
        data-testid="sticky-whatsapp-btn"
        aria-label="WhatsApp"
      >
        <span className="absolute inset-0 rounded-full animate-ping bg-[#25D366] opacity-30" />
        <MessageCircle className="w-6 h-6 relative" />
      </a>
    </div>
  );
};
